import { proxyCompare, proxyShallowEqual } from 'proxyequal';
export function updateCacheLine(cache, lineId, value) {
  for (var i = lineId; i < cache.length - 1; i++) {
    cache[i] = cache[i + 1];
  }

  cache[cache.length - 1] = value;
}
export function shallowEqualHit(cache, args) {
  for (var i = 0; i < cache.length; ++i) {
    var found = cache[i];
    var _found = found,
        lineArgs = _found.args,
        lineAffected = _found.affected;

    if (args.length !== lineArgs.length) {
      continue;
    }

    for (var j = 0; j < args.length; ++j) {
      var a = args[j];
      var b = lineArgs[j];
      var useAffected = lineAffected[j] ? lineAffected[j].useAffected : [];
      var resultAffected = lineAffected[j] ? lineAffected[j].resultAffected : [];

      if (a === b || typeof a === 'object' && (useAffected.length === 0 || proxyShallowEqual(a, b, useAffected)) && (resultAffected.length === 0 || proxyCompare(a, b, resultAffected))) {//pass
      } else {
        found = null;
        break;
      }
    }

    if (found) {
      updateCacheLine(cache, i, found);
      return found;
    }
  }

  return undefined;
}